import React from 'react';

import ReactDOM from 'react-dom';
import { Button } from '@jd/find-react';

 

import KeeVue from '../base/KeeVue.js'
import FeasComponents from './FeasComponents.js'
import FsResizers from './FsResizers.js'

import $ from 'jquery';



export default class FeasPage extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				randId: this.getRandString(),
				currentUserName: window.currentUserName,
				currentUserId: window.currentUserId,
				background: '',
				backgroundColor: '#FFFFFF',
				myComponents: null,
				keePage:{},
				userConfig:null,
				viewName: "testttttt",
				viewer: {
					test: 'test value'
				},
				crudExt: null,
				showConfig: false,
				targetApp:'',
				isActived:false,
			}

}

componentDidMount(){
			let that = this;
			this.onEvent(this.props.name + ".active", (obj)=> {
				that.sendEvent("active", obj);
			});
			this.onEvent("changeBackground", this.initComponents);
			that.initComponents();
			
		 
			
		}

			resize=(item)=> {
				this.sendEvent("resize." + item.alias);
			}
			
			getTableIdFromArray=(compArray,id)=>{
				if(!compArray)
				{
					return null;
				}
				for(let i=0;i<compArray.length;i++)
				{
					let tableId = this.getTableIdFromArray(compArray[i].child,id);
					// 看看tableId 里面是否包含这个id
					if(tableId)
					{
						return tableId
					}
					
					
					
					if(compArray[i].cp.tableId)
					{
						// found
						tableId = compArray[i].cp.tableId;
					 
						let target = this.getComponentById(id, compArray[i].child);
						if(target != null)
							return tableId;
							
					}
				}
			}
			
			sendGuidHelp=()=>{
				
				//   {position: 'bottom', title:'新建表单', text: "点击新建表单按钮打开表单编辑工具，开始创建属于您表单。", offset: 15},
				//   {position: 'bottom', title:'表单标题及描述', text: "请为表单起一个标题，并添加描述。表单标题和描述将会出现在表单填报页面。", offset: 15},
				//   {position: 'bottom', title:'添加组件', text: "点击或向左侧拖拽组件添加表单字段，并可以通过拖拽来改变组件顺序。", offset: -15},
				//   {position: 'bottom', title:'保存表单', text: "点击保存按钮创建表单，下次可继续进行编辑操作。", offsetX: -15},
				//   {position: 'top', title:'开启收集', text: "表单创建之后需要开启收集才可以分享至用户进行填报。", offset: -15},
				//   {position: 'bottom', title:'发放表单', text: "将二位码发放至用户侧，用户可以通过手机扫码填报。", offsetX: -15},
				//   {position: 'bottom', title:'查看详情', text: "点击详情，可以查看表单的填报结果。", offsetX: -15}
				
				
				let data=[
				           {target:window.domTargets["fsText001"], ox:120,oy:10,ix:5,iy:15,   title:'表单标题及描述', text: "请为表单起一个标题，并添加描述。表单标题和描述将会出现在表单填报页面。"},
						   {target:window.domTargets["left"], ox:120,oy:0,ix:5,iy:15,   title:'添加组件', text: "点击或向左侧拖拽组件添加表单字段，并可以通过拖拽来改变组件顺序。"},
						   {target:window.domTargets["right"], ox:-300,oy:0,ix:295,iy:15,   title:'编辑组件', text: "设置组件名称、默认值、格式、是否必填等属性。"},
						   {target:window.domTargets["saveBtn"], ox:-230,oy:50,ix:270,iy:-15,   title:'保存表单', text: "点击保存按钮创建表单，下次可继续进行编辑操作。"},
						   {target:window.domTargets["shoujiBtn"], ox:-210,oy:50,ix:260,iy:-15,   title:'开启收集', text: "表单创建之后需要开启收集才可以分享至用户进行填报。"},
				        				        
						];
						
				for(let i=0;i<data.length;i++)
				{
					if(!data[i].target)
					{
						setTimeout(()=>{
							this.sendGuidHelp();
						},200);
						return ;
					}
				}
				
				 this.sendEvent("showHelpGuide",data,"build");
				
			}
			
			initComponents=()=> {
				console.log("FeasPage组件编号："+this.state.randId+" namebbb:"+this.props.nameB);
				let that = this;
				console.log("zhixing: initComponents()");
				console.log(this.props.components);
				
				// 要计算一下
				
				
				this.state.isActived = true;
				
				if(this.props.components  ) {
					console.log("this.props.components 不为空")
					//alert("参数不为空")
					
					that.components = this.props.components;
					
					

					 let state = JSON.parse(JSON.stringify(this.state));


						state.myComponents = that.props.components;
						if(that.props.components  && that.props.components.length > 0) {
							state.viewName = that.props.components[0].alias + "viewName";
						}
						if(that.isNotBlank(state.viewName)) {
							console.log("注册到全局对象CMap:" + state.viewName);
							window.CReactMap[state.viewName] = that;
							if(this.props.debug !== true)
							{
								that.initComponentStyle(that.props.components, state.viewName);
								that.initPageComponent(that.props.components, state.viewName);
							}
							else
							{
								that.initPageComponentViewName(that.props.components, state.viewName);
							}
						} else {
							if(this.props.debug !== true) {
								that.initComponentStyle(that.props.components)
							}
						}
						if(that.props.keePage) {
							 
							if(that.props.keePage.config ) {
								let config = that.props.keePage.config;
								if(config  && this.isNotBlank(config.bgImg)) {
									state.background = "url(" + window.fileUrl + ("/api/fs/getById?ids=") + config.bgImg + ")";
								} else {
									this.setVueAttr(config, "bgImg", "");
								}
								state.backgroundColor = config.background;
								this.state.keePage = that.props.keePage ;
							}
						}
						
						this.fullPage = window.appName +"/"+ that.props.keePage.code;
						// 如果指定了创建的人员
						if(this.props.parameters&&this.props.parameters.createUserIds)
						{
							this.initComponentUserIds(this.props.parameters.createUserIds);
						}
						//更新生效
						this.refresh();
					   if(window.isReport&&this.props.keePage.code=='formIndex'&&this.props.debug)
						{
							//alert("是一个报表页面的表单，需要做指引页面");
							
							 // 所有dom都渲染好了，再发布事件
							 
							this.sendGuidHelp();
						}


				} else {
						console.log("this.props.name："+this.props.name)
					if(!this.isNotBlank(this.props.name)) {
						return;
					}
					console.log("----------------------------------------");
					let appCodeInfo = "";
					if(typeof this.props.appCode !== "undefined" && this.props.appCode  && this.props.appCode !== "") {
						appCodeInfo = "&appCode=" + this.props.appCode;
					}
					let keePageUrl = "/keePage/getByCode";
					if(typeof window.previewUrl !== "undefined") {
						keePageUrl = window.previewUrl + keePageUrl;
					}
					let arry = this.props.name.split("/");
					
					let pageCode=this.props.name;
					
					if(arry.length===2&&this.isNotBlank(arry[0]&&this.isNotBlank(arry[1])))
					{
						this.targetApp = arry[0];
					}
					else
					{
						if(typeof this.props.appCode !=="undefined" && this.props.appCode!==null&&this.props.appCode!=="undefined")
						{
							this.targetApp = this.props.appCode;
						}
						
						if(this.targetApp)
						{
							if(this.props.name.indexOf("/")!=0)
							{
								pageCode=this.targetApp+"/"+this.props.name;
							}
							else
							{
								pageCode=this.targetApp+this.props.name;
							}
							
							
						}
						
					}
				 
					
					
					console.log(keePageUrl + "?code=" + this.props.name + appCodeInfo);
					this.fullPage = this.props.name + appCodeInfo;
					this.doRequest(keePageUrl + "?code=" + pageCode + appCodeInfo+"&preFetch=true", (data)=> {
						if(data.success === false) {
							alert("页面加载失败，请重试！");
							console.log("触发error事件！！！");
							that.$emit("error");
							return;
						}
						let cpNames = data.componentNames;
						this.loadPageComponents(cpNames,()=>{
								if(this.isNotBlank(data.pageXmlConfig) === true && data.pageXmlConfig !== "[]") {
								if(this.props.debug || (this.props.name  && this.props.name.indexOf("vueComponentProp") === 0)) {
									that.state.showConfig = true;
								}
								if(data.appConfigJsonInfo)
								{
									data.userConfig = JSON.parse(data.appConfigJsonInfo);
									that.state.userConfig = data.userConfig;
								}
								//console.log("配置值：" + data.pageXmlConfig);
								
							
								let cs = JSON.parse(data.pageXmlConfig);
								if(data.config ) {
									let config = JSON.parse(data.config);
									if(config  && this.isNotBlank(config.bgImg)) {
										that.state.background = "url(" + window.fileUrl + ("/api/fs/getById?ids=") + config.bgImg + ")";
									}
									that.state.backgroundColor = config.background;
									let totalWidth = parseInt(config.width.replace("px"));
									that.initComponentSize(cs, totalWidth);
									
									this.state.keePage.config=config;
								}
								
								if(that.props.viewName)
								{
									that.state.viewName = that.props.viewName;
								}
								else
								{
									that.state.viewName = data.id;
								}
								
								if(this.isNotBlank(that.state.viewName)) {
									window.CReactMap[that.state.viewName] = that;
								}
								
								// alert(  this.props.name);
								
								if(this.props.name&&this.props.name.indexOf("REPORT_")!=-1&&this.props.name.indexOf('/formIndex')!=-1)
								{
									// 追加一个按钮特性
									//alert("report model")
								/*	if(cs&&cs.length>0)
									{ }*/
									
									this.doRequest("/reportTemplate/getByAppcode?appCode="+this.props.name,(retTemplate)=>{
										that.initPageComponent(cs, that.state.viewName);
										that.state.myComponents = cs;
										that.components = cs;
										that.initEventBind(data.sqlTemplate, cs);
										
										let compDescription = this.getComponentByAlias(that.components,"fsText002");
										let compName=this.getComponentByAlias(that.components,"fsText001");
										
										if(compDescription)
										{
											compDescription.cp.title = retTemplate.description;
											compDescription.cp.maxLength=100;
										}
										
										if(compName)
										{
											compName.cp.title = retTemplate.name;
											compName.cp.maxLength=20;
										}
										
										
										console.log("更新feaspage里面的组件")
										//that.setState(that.state);
										that.refresh();
									});
									
								}
								else
								{
									that.initPageComponent(cs, that.state.viewName);
									that.state.myComponents = cs;
									that.components = cs;
									that.initEventBind(data.sqlTemplate, cs);
									
									console.log("更新feaspage里面的组件")
									//that.setState(that.state);
									that.refresh();
								}
								
								


							}
						});
					},{
						appCode : this.targetApp,
						appId:window.appId+ window.getCookie(window.keyName + "_token"),
						isPreview:(this.props.parameters?this.props.parameters.isPreview:false)
					});
				}
			}
			brige=()=> {
				this.crudExt["active"].apply(this);
			}
			bindExtEvent=(p)=> {
				let that = this;
				let eventName = p.replace("on_", "");
				// console.log("绑定事件：" + eventName);
				that.$on(eventName, this.crudExt[p]);
			}
			initEventBind=(sourceCodeString, components)=> {
				let that = this;
				 window.crudExt = null;
					try
					{ 
						// console.log(sourceCodeString);
					   let crudExt = eval(sourceCodeString.replace("var crudExt =","window.crudExt ="));
					}
					catch(err)
					{
						console.log(sourceCodeString);
					   alert("该页面交互代码存在错误："+err);
					   console.error(err);
					}
				
				
				
				

				if(typeof window.crudExt !== "undefined"&& window.crudExt!=null) {
					this.crudExt = window.crudExt;

					for(let p in this.crudExt) {
						if(p.indexOf("on_") === 0) {
							this.bindExtEvent(p);
						}
						if(typeof this[p]==="undefined")
						{
							this[p] = this.crudExt[p];
						}
					}
					
					this.bindComponentActions(components);
					
					
					
					this.crudExt.viewName = this.state.viewer;
					if(typeof this.crudExt["active"] !== "undefined") {
						that.$on("active", this.crudExt["active"]);
					}
					if(typeof this.crudExt["before"] !== "undefined") {
						that.parameters = that.props.parameters;
						
						//设置默认的实体对象
						if(this.state.keePage.config&&this.state.keePage.config.entity)
						{
							that.entityName = this.state.keePage.config.entity;
						}
						
						
						this.crudExt.before.bind(this)(components, that,that.parameters);
					}
					
					// 如果指定了创建的
					if(this.props.parameters&&this.props.parameters.createUserIds)
					{
						this.initComponentUserIds(this.props.parameters.createUserIds);
					}
					
					// 不能屏蔽
					setTimeout(()=> {
						that.$emit("active", that.props.parameters);
						that.state.isActived = true;
						that.refresh();
					}, 50);
				}
			}
			
			bindComponentActions=(componentArray)=>{
				
				for(let i = 0; i < componentArray.length; i++) {
					let c = componentArray[i];
					if(c.actions) { 
						c.actions.map((action,index)=>{
							
							if(action.actionType=='openDlg')
							{
								this.bindActionOpenDlg(c,action);
							}
							
							if(action.actionType=='openRightDetail')
							{
								this.bindActionOpenRightDetail(c,action);
							}
							
							if(action.actionType=='openBottom')
							{
								this.bindActionOpenBottom(c,action);
							}
							
							if(action.actionType=='query')
							{
								this.bindActionQuery(c,action);
							}
							
							if(action.actionType=='delete')
							{
								this.bindActionDelete(c,action);
							}
							
							if(action.actionType=='openSp')
							{
								this.bindActionOpenSp(c,action);
							}
							
							
						})
						
					}
					if(  c.child ) {
						 
						this.bindComponentActions(c.child);
					}
				}
				
				
			}
			
			bindActionOpenBottom=(c,action)=>{
				
				this.$on(c.alias+"."+action.eventName, (item,row)=>{
				 
					if(action.pageName)
					{
						if(action.pageName.indexOf("/")!=-1)
						{
							this.openBottomPage("M::"+action.pageName, {})
						}
						else
						{
							this.openBottomPage("M::/"+action.pageName, {})
						}
						
					} 
				});
				
			}
			bindActionOpenDlg=(c,action)=>{
				let pageName= action.pageName;
				
				if(!pageName)
				{
					return ;
				}
				
				if(action.pageName.indexOf("/")==-1)
				{
					pageName = "/"+pageName;
					 
				}
				
					this.$on(c.alias+"."+action.eventName, (item,row)=>{		
						
						if(action.pageName)
						{
							let loadUrl="";
							if(row&&row.id)
							{
								if(action.dbModel)
								{
									// 需要转驼峰方式
									let model = this.toTuoFeng(action.dbModel);
									loadUrl="/"+model+"/get?id="+row.id;
								}
							}
							
							this.openDlgPage("M::/"+ pageName, {
								title: (row?'修改':'新增'),
								size: 'normal',
								loadUrl: loadUrl,
								row:row,
								extraParas: {},
								onChanged: (ret, form)=> {
									this.showMessage(ret);
									let tableArray = [];
									
									
									let components=this.props.components?this.props.components:this.state.myComponents;
									this.findFsTable(c,components,tableArray); 
									if(tableArray)
									{
										tableArray.map((table,index)=>{
											 
											this[table.alias].query( );
										})
									}
									
								 
									
									form.$emit("changed", ret)
									 
								}
							})
						} 
					});
				
				
			}
			bindActionOpenSp=(c,action)=>{
				
				let pageName= action.pageName;
				if(action.pageName.indexOf("/")==-1)
				{
					pageName = "/"+pageName;
					 
				}
					this.$on(c.alias+"."+action.eventName, (item,row)=>{		
						
						  
						if(action.pageName)
						{ 
							if(!row)
							{
								row={};
							}
							
							// alert(action.pageName)
							
							// this.openSpPage(action.pageName,{id:row.id});
							
							this.sendEvent("HashChange","2018_M::"+this.targetApp+"/"+action.pageName,{
								fromPage:this,
								row:row
							})
							//this.openHashSp("2018_M::"+this.targetApp+"/"+action.pageName,row);
							 
							// this.openRightPage("M::/"+pageName, {
							// 		         id: row.id,
							// 		         title: row.title,
							// 		         name: row.name, 
							// 		        // loadUrl: '/aiocModel/get?id=' + row.id,
							// 		         type: 'lunbo_index',
							// 		         onChanged: (ret,owner)=> { 
							// 		                 this.showMessage(ret); 
													 
							// 						 let tableArray = [];
							// 						 let components=this.props.components?this.props.components:this.state.myComponents;
							// 						 this.findFsTable(c,components,tableArray);
							// 						 if(tableArray)
							// 						 {
							// 						 	tableArray.map((table,index)=>{
							// 						 		this[table.alias].query( );
							// 						 	})
							// 						 }
													 
							// 		         }
							// }) 		 
						} 
					});
				
			}
			
			openHashSp = (sp,pdata) => {
			
			  // 参数处理 
			  var params = "";
			  var url = window.location.href; 
			  var urls = url.split("?"); 
			  var existsSp = false; 
			  if (!existsSp) {
			    if (params) {
			      params = "sp=" + sp + "&" + params;
			    }
			    else {
			      params = "sp=" + sp;
			    } 
			  }
				
				if(pdata&& typeof pdata!='string'&&typeof pdata=='object')
				{
					for(var p in pdata)
					{
						 params +="&"+p+"="+pdata[p];
					}
				}
			
			
			
			  window.history.pushState({ sp: sp }, "", "?" + params);
			
			  // 触发一次变更，fs-view 修改了当前url，通过值的绑定来更新
			  //this.onHashChange();
			
			}
			
			bindActionOpenRightDetail=(c,action)=>{
				
				
				let pageName= action.pageName;
				if(action.pageName.indexOf("/")==-1)
				{
					pageName = "/"+pageName;
					 
				}
					this.$on(c.alias+"."+action.eventName, (item,row)=>{		
						
						if(action.pageName)
						{ 
							if(!row)
							{
								row={};
							}
							
							this.openRightPage("M::/"+pageName, {
									         id: row.id,
									         title: row.title,
									         name: row.name, 
									        // loadUrl: '/aiocModel/get?id=' + row.id,
									         type: 'lunbo_index',
									         onChanged: (ret,owner)=> { 
									                 this.showMessage(ret); 
													 
													 let tableArray = [];
													 let components=this.props.components?this.props.components:this.state.myComponents;
													 this.findFsTable(c,components,tableArray);
													 if(tableArray)
													 {
													 	tableArray.map((table,index)=>{
													 		this[table.alias].query( );
													 	})
													 }
													 
									         }
							}) 		 
						} 
					});
				
				
			}
			
			
			bindActionQuery = (c,action) =>{
				
				this.$on(c.alias+"."+action.eventName, (item,row)=>{
					
					// 找到这个组件，然后获取其所在的form组件，然后调用表格组件的query方法；
					let components=this.props.components?this.props.components:this.state.myComponents;
					if(components)
					{
						let fsForm = this.findFsForm(c,components);
						
						if(!fsForm)
						{
							alert("未找到所在的表单组件，请确认按钮在当前表单");
							return;
						}
						
						let tableArray = []; 
						this.findFsTable(c,components,tableArray);
						
						if(tableArray)
						{
							tableArray.map((table,index)=>{
								this[table.alias].query(this[fsForm.alias].getData());
							})
						}
						else
						{
							alert("未找到任何表格组件");
							return;
						} 
					} 
				});
				
			}
			
			bindActionDelete=(c,action)=>{
				
					this.$on(c.alias+"."+action.eventName, (item,row)=>{ 
						if(action.url)
						{
							this.doRequest(action.url,(ret)=>{
								// 刷新表格 
								let tableArray = []; 
								let components=this.props.components?this.props.components:this.state.myComponents;
								
								this.findFsTable(c,components,tableArray);
								if(components)
								{
									if(tableArray)
									{
										tableArray.map((table,index)=>{
											this[table.alias].query();
										})
									}
								}
								  
								
							},{
								id:row.id,
								ids:row.id,
							}) 
						} 
					}); 
			}
			
			
			initComponentSize=(componentArray, totalWidth)=> {
				for(let i = 0; i < componentArray.length; i++) {
					let c = componentArray[i];
					if(c.style.position === "absolute") {
						if(c.style.left ) {
							c.style.left = (parseInt(c.style.left.replace("px")) * 100 / totalWidth) + "%";
						}
						if(c.style.right ) {
							c.style.right = (parseInt(c.style.right.replace("px")) * 100 / totalWidth) + "%";
						}
						if(c.cp.fixWidth !== true && c.style.width ) {
							c.style.width = (parseInt(c.style.width.replace("px")) * 100 / totalWidth) + "%";
						}
					}
					if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
						if(c.isContainer===true&&c.type!=='layout'&&c.type!=='form')
						{
							if(c.style.width!==null)
							{
								totalWidth = parseInt(c.style.width.replace("px"));
							}
						}
						this.initComponentSize(c.child, totalWidth);
					}
				}
			}
			initComponentStyle=(componentArray)=> {
				// for(let i = 0; i < componentArray.length; i++) {
				// 	let c = componentArray[i];
				// 	if(c.style.position === null) {
				// 		this.setVueAttr(c.style, "position", "");
				// 	}
				// 	if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
				// 		this.initComponentStyle(c.child);
				// 	}
				// }
			}
			initPageComponentViewName=(componentArray, viewName)=> {
				for(let i = 0; i < componentArray.length; i++) {
					let c = componentArray[i];
					c.viewName = viewName;
					if(c.cp.disabled!==true&&c.cp.disabled!==false)
					{
						c.cp.disabled = false;
					}
					if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
						this.initPageComponentViewName(c.child, viewName);
					}
				}
			}
			initComponentUserIds=(userIds)=>{
				this.initPageComponentUserIds(this.components,userIds);
			}
			initPageComponentUserIds=(componentArray, userIds)=> {
				for(let i = 0; i < componentArray.length; i++) {
					let c = componentArray[i];
					
					if(c.createUserId)
					{
						c.visiable = (userIds.indexOf(c.createUserId)!=-1);
					}			
					
					if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
						this.initPageComponentUserIds(c.child, userIds);
					}
				}
			}
			
			initPageComponent=(componentArray, viewName)=> {
				for(let i = 0; i < componentArray.length; i++) {
					let c = componentArray[i];
					c.errorMsg = "";
					c.error = false;
					c.viewName = viewName;
					c.key = c.id;
					c.parentView = this.parentView;
					c.userConfig= this.state.userConfig;
					if( c.cp.visiable ) {
						// if(c.cp.visiable === true||c.cp.visiable === "true") {
							c.visiable = true;
						// } else {visiable
						// 	c.visiable = false;
						// }
					} else {
						if(c.visiable!=false)
						{
							c.visiable = true;
						}
						
					}
					
					if(c.cp.disabled!==true&&c.cp.disabled!==false)
					{
						c.cp.disabled = false;
					}
					
					c.isSelected = false;
					c.isKeeShowBorder = false;
					 c.isMouseOver=false;
					c.rowid = c.id;
					c.templateForm = null;
					if(typeof c.value === "undefined"||c.value==null) {
						c.value = "";
					}
					else
					{
						if(this.props.debug)
						{
							c.value = "";
						}
					}
					
					if(!c.extProps)
					{
						c.extProps={}
					}
					
					if(this.isNotBlank(c.alias) === false)
						c.alias = c.id;
					c.hasPermission = true;
					if(this.isNotBlank(c.permission)) {
						c.hasPermission = false;
						let permissions = c.permission.split(",");
						for(let n = 0; n < permissions.length; n++) {
							if(this.isNotBlank(permissions[n]) && this.isNotBlank(window.userPermissions[permissions[n]])) {
								c.hasPermission = true;
								break;
							}
						}
						if(c.hasPermission === false) {
							c.visiable = false;
						}
					}
					if(this.isNotBlank(c.cp.modelName)) { // 要设置一个值
						this.$set(this.query, c.cp.modelName, c.value);
					}
					// if(this.props.po  && this.isNotBlank(c.cp.field)) { // 要设置一个值
					// 	if(this.getValueByAttr(this.props.po, c.cp.field) === null) {
					// 		if(c.name === 'fs-table') {
					// 			this.setVueAttr(this.props.po, c.cp.field, []);
					// 		} else {
					// 			this.setVueAttr(this.props.po, c.cp.field, null);
					// 		}
					// 	}
					// }
					if( c.child  && c.child.length > 0) {
						this.initPageComponent(c.child, viewName);
					}
				}
			}
			openAppConfig=()=> {
				console.log(("/appBuild?token=" +this.getCookie("token") + "&pid=" + this.props.name));
				let appName = this.props.name.substring(0, this.props.name.indexOf("/"));
				let that = this;
				
				
				
				this.doRequest("/jdccApp/listData?search_EQ_name=" + appName, (ret)=> {
					that.openDlgPage("M::jdccApp/appVersionLog", {
						title: '选择版本',
						size: 'normal',
						loadUrl: '',
						extraParas: {
							name: appName,
							version: (ret&&ret.rows&& ret.rows[0])?ret.rows[0].version:0,
							pid:   that.props.name,
						},
						onChanged:function (ret, form) {
							window.location.reload();
						}
					})
				});
			}
			
			
			
			onChanged=(ret)=> {
				 
				this.$emit("changed", ret);
			}
			onCommand=(cmdName, item, po, thisForm, parentForm)=>{

				//this.setState(this.state);
				this.$emit("command", cmdName, item, po, thisForm, parentForm);

			}

			componentDidUpdate(){
				this.needRefresh = false;
			}
			shouldComponentUpdate(nextProps, nextState) {
				
				return true;
				
				if(this.needRefresh)
				{
					
					return true;
				}


				for(let p in this.props)
				{
					if(this.props[p]!==nextProps[p])
					{
						//console.log(p,JSON.stringify(this.props[p]));
						//console.log(p,JSON.stringify(nextProps[p]));
						
						return true;
					}
				}
				
				for(let p in this.state)
				{
					if(this.state[p]!== nextState[p])
					{
						return true;
					}
				}
				console.log("feasPage计算后，不需要更新")
				return false;
					
					
				// if(this.lastStateString ===(JSON.stringify(nextState)+JSON.stringify(nextProps)))
				// {
				// 	console.log("经过计算，不需要更新");
				// 	return false;
				// }
				// console.log("经过计算，需要更新");
				//console.log("feasPage计算是否需要渲染");
				return true;

			   //  if (nextState.componentTypes===this.state.componentTypes) {

			   //    return false;
			   //  }
			   //  return true;
			}

			  componentWillReceiveProps(nextProps){
				//   console.log("feasPage收到nextProps")
				  // let that = this;
				 // this.setState(this.state);
				  // setTimeout(function(){
					 //  if(JSON.stringify(that.props)==JSON.stringify(nextProps))
					 //  {

					 //  }
					 //  else
					 //  {
						//   that.initComponents();
					 //  }

				  // },1000)

			  }


		//<div>组件个数:{this.props.components&&this.props.components.length}  </div>

  render(){

	 // this.lastStateString = JSON.stringify(this.state)+JSON.stringify(this.props);

      // console.log("重新渲染feasPage");
	  
	  if(this.props.po&&this.props.po.viewName&& window.CMap[this.props.po.viewName])
	  {
	  	// 找当前页面维护的目标component的tableId是多少
	  	
	  	let targetComponents = window.CMap[this.props.po.viewName].components;
	  	
	  	if(targetComponents)
	  	{
	  		let tableId = this.getTableIdFromArray(targetComponents,this.props.po.id);
	  		
	  		if(tableId)
	  		{
	  			this.tableId = tableId;
	  		}
	  	} 
	  }
// 'display':(this.state.isActived?'block':'none'),
let name = this.props.name;

 
  
  if(window.isPub)
  {
	  //alert("pub 模式！");
	  return (
	  
	  
	   
	  
	  <div id={this.state.randId} page={this.fullPage} className={`feas-page-container `} style={{'backgroundImage':this.state.background,
	  'minWidth':(this.props.minWidth?this.props.minWidth:'0px'),
	  
	   'overflowX':(this.props.debug?'visible':'hidden'),'padding':(this.props.debug&&window.isReport?'16px':''),
	   
	   'backgroundColor':(this.props.keePage?this.props.keePage.config.background:'') }} >
	   
	  	 
	  	 
	  	{
	  		this.props.components?<FeasComponents  components={this.props.components} query={this.props.query} keePage={this.props.keePage}
	  	parentViewName={this.props.parentViewName} po={this.props.po}   
	  	 onChanged={this.onChanged}
	  	 onCommand={this.onCommand}
	  	 debug={this.props.debug}
	  	></FeasComponents>
	  		:
	  		<FeasComponents  components={this.state.myComponents} query={this.props.query} keePage={this.props.keePage}
	  		parentViewName={this.props.parentViewName} po={this.props.po}    debug={this.props.debug}
	  		onChanged={this.onChanged}
	  		onCommand={this.onCommand}
	  		></FeasComponents>
	   
	  	}
	  
	   
	  
	  
	  </div>
	  
	  
	  )
  }
return(



<div id={this.state.randId} page={this.fullPage} className={`feas-page-container`} 
style={{'backgroundImage':this.state.background,
'minWidth':(this.props.minWidth?this.props.minWidth:'0px'),
'minHeight':'30px',
'display':(this.state.isActived?'block':'none'),
 'overflowX':(this.props.debug?'visible':'hidden'),'padding':(this.props.debug&&window.isReport?'16px':''),'overflowY':(this.props.debug?'visible':'auto'),
 'backgroundColor':(this.props.keePage?this.props.keePage.config.background:'') }} >
    {
		!this.props.debug &&window.hasPermission("DEV") && <div className={`app-config-btn`} onClick={this.openAppConfig} style={{ minWidth:' 15px', position:'absolute'}} >
        <div className={`app-config-btn-div`} >
           <span title="页面开发入口" className={`glyphicon glyphicon-cloud`}  style={{cursor: 'pointer',fontSize: '26px' }} ></span>
        </div>
    </div>


	}
	 
	 
	{
		this.props.components?<FeasComponents  components={this.props.components} query={this.props.query} keePage={this.props.keePage}
	parentViewName={this.props.parentViewName} po={this.props.po}   
	 onChanged={this.onChanged}
	 onCommand={this.onCommand}
	 debug={this.props.debug}
	></FeasComponents>
		:
		<FeasComponents  components={this.state.myComponents} query={this.props.query} keePage={this.state.keePage}
		parentViewName={this.props.parentViewName} po={this.props.po}    debug={this.props.debug}
		onChanged={this.onChanged}
		onCommand={this.onCommand}
		></FeasComponents>
 
	}


	{
	  this.props.debug && <FsResizers components={this.props.components} ></FsResizers>
	}


</div>
  );}
 }
